<template>
  <div class="user-profile-display_upd" v-if="userData" :class="{ [curTheme]: true }">
    <div class="page-container_pcr">
      <div class="block-wrap">

        <div class="upd_img-block">
          <img :src="avatarUrl" class="upd_avatar">
          <div class="upd_img-info-wrap">
            <div class="upd_controls">
              <block-user
                :userData="userData"
                :userId="userId"
                @on-user-unblocked="fetchProfileData"
                @on-user-blocked="fetchProfileData"
              />
              <button
                v-if="userData.Transient.Permissions.USER_DELETE"
                @click="deleteUser"
                class="upd_control-btn lite-button sm-button">Удалить</button>
              <user-roles-control :userId="userId" class="upd_control-btn"/>
              <user-verifications-control :userId="userId" class="upd_control-btn"/>
              <div
                v-if="$store.getters['user/isAuthenticated'] && !isMyProfile"
                class="upd_icon-btns-wrap">
                <claim-add
                  v-if="userId"
                  class="upd_icon-btn upd_claim-add"
                  entity-type="User"
                  :entity-id="userId"/>
                <bookmarked
                  v-if="isBookmarked !== null"
                  :is-bookmarked="isBookmarked"
                  @click="bookmarkedClicked"
                  class="upd_icon-btn upd_bookmarks"/>
              </div>
            </div>

            <div
              v-if="userData && userData.Transient.IsBlocked"
              class="upd_user-blocked">
              <span class="upd_block-user-ctr">
                <i class="upd_user-blocked-icon el-icon-warning"></i>
                Пользователь
                заблокирован<template v-if="userData.Transient.Blocking.Cause">,
                причина: {{ userData.Transient.Blocking.Cause }}</template>
              </span>
            </div>

            <div
              v-if="userRights.length !== 0"
              class="user-rights">
              <span class="user-rights-title">Роли на платформе:</span>
              <template v-for="(right) in userRights">
                <div :key="right.Role">
                {{ right.RoleTitle }}
                </div>
              </template>
            </div>
            <div class="upd_fio">
              {{ fio }}
              <el-tooltip
                v-if="isIPUser"
                content="Верифицированный участник платформы от вуза"
                placement="top">
                <div class="ip-user">
                </div>
              </el-tooltip>
            </div>
            <div class="upd_org" v-if="curOrg">{{ curOrg }}</div>
            <div class="upd_grade" v-if="userData.AcademicDegree">
              <span class="upd_grade_title">Ученая степень:</span>
              {{ userData.AcademicDegree.join(', ') }}</div>
            <div class="upd_grade" v-if="userData.AcademicTitle">
              <span class="upd_grade_title">Учёное звание:</span>
              {{ userData.AcademicTitle }}</div>
            <div class="upd_info" v-if="userData.Mail">
              <i class="upd_icon el-icon-message"></i> {{ userData.Mail }}</div>
            <div class="upd_info" v-if="userData.Phone">
              <i class="upd_icon el-icon-phone"></i> {{ userData.Phone }}</div>
          </div>
        </div>

        <div class="upd_job-block" v-if="userData.Jobs && userData.Jobs[0]">
          <div class="upd_job_title">Место работы</div>
          <div class="upd_job_org" v-if="userData.Jobs[0].Organization">
            {{ this.userData.Jobs[0].Organization }}
          </div>
          <div class="upd_job_dep" v-if="userData.Jobs[0].Department">
            {{ this.userData.Jobs[0].Department }}
          </div>
          <div class="upd_job_post" v-if="userData.Jobs[0].Post">
            {{ this.userData.Jobs[0].Post }}
          </div>
        </div>
        <template v-if="isMyProfile">
          <div class="upd_game-block" v-if="gameData">
            <router-link
              class="help-link"
              :to="{ path: '/help/6'}"
              target="_blank">
              Подробнее о баллах и репутации в разделе Помощь
            </router-link>
            <div class="upd_game_score" v-if="gameData.Score">
              <div class="game-score-button" v-on:click="isShowScore = !isShowScore">
                Баллы <span class="game-count">{{ this.gameData.Score }}</span></div>
                <template v-for="(action) in gameData.Actions">
                  <div class="action_item" v-if="isShowScore && action.Score !== 0"
                    :key="`score-${action.Action}`">
                      <div class="game_el_value">{{ getGameElementScore(action) }}</div>
                      <div class="game_el_name">{{ action.ActionTitle }}</div>
                  </div>
                </template>
            </div>
            <div class="upd_game_reputation" v-if="gameData.Reputation">
              <div class="game-reputation-button" v-on:click="isShowReputation = !isShowReputation">
                Репутация <span class="game-count">{{ this.gameData.Reputation }}</span></div>
                <template v-for="(action) in gameData.Actions">
                  <div class="action_item" v-if="isShowReputation && action.Reputation !== 0"
                    :key="`reputation-${action.Action}`">
                      <div class="game_el_value">{{ getGameElementReputation(action) }}</div>
                      <div class="game_el_name">{{ action.ActionTitle }}</div>
                  </div>
                </template>
            </div>
          </div>
        </template>
        <template v-else-if="gameData">
          <div class="user-reputation" v-if="gameData.Reputation">
            Репутация {{ this.gameData.Reputation }}
          </div>
        </template>
        <div
          v-if="userRanks"
          class="role-statuses">
          <div
            v-for="(rank) in userRanks"
            :key="`user-rank-${rank.Role}`"
            :class="[rank.Role === 'USERSTATUS' ? 'role-status-main' : '', 'role-status']"
            :set="roleRank = getRoleRank(rank.Rank.Name)">
            <div
              class="role-score"
              v-if="isMyProfile">
              {{ convertScoreToSting(rank.Reputation) }} репутации
            </div>
            <div
              :class="rank.Role === 'USERSTATUS' ? 'role-main' : 'role-secondary'">
              {{ rank.RoleTitle }}: {{ rank.Rank.Title }}
            </div>
            <div class="role-rank">
              <template v-for="i in 4">
                <div
                  :class="(roleRank >= i) ?
                    'rank-fill-ico' : 'rank-empty-ico'"
                  :key="`rank-ico-${i}`">
                </div>
              </template>
            </div>
            <div
              class="role-next-status"
              v-if="rank.Rank.NextRankName && isMyProfile">
              До статуса '{{ rank.Rank.NextRankTitle }}' осталось
              {{ convertScoreToSting(rank.Rank.NextRankReputationMin - rank.Reputation) }}
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import Bookmarked from '@/components/Bookmarked';
import UserRolesControl from '@/components/UserRolesControl';
import UserVerificationsControl from '@/components/UserVerificationsControl';
import ClaimAdd from '@/components/ClaimAdd';
import BlockUser from '@/components/BlockUser';

export default {

  components: { Bookmarked, UserRolesControl, UserVerificationsControl, ClaimAdd, BlockUser },

  props: {
    userId: null,
  },

  data() {
    return {
      userData: null,
      avatar: null,
      gameData: null,
      isBookmarked: null,
      isShowScore: true,
      isShowReputation: true,
      userRanks: [],
      userRights: [],
      isIPUser: false,
    };
  },

  mounted() {
    if (this.userId) {
      this.fetchUserData(this.userId);
    }
  },

  computed: {

    fio() {
      return `${this.userData.Surname} ${this.userData.Name} ${this.userData.Patronymic}`;
    },

    curOrg() {
      let curOrg = null;
      if (this.userData.Jobs && this.userData.Jobs[0]
        && this.userData.Jobs[0].Organization
      ) {
        curOrg = this.userData.Jobs[0].Organization;
      }
      return curOrg;
    },

    avatarUrl() {
      return this.avatar ?
        `${this.$store.state.apiUrl}${this.avatar}` : '/static/grx/no-image.png';
    },

    isMyProfile() {
      const userId = this.$store.getters['user/getUserId'];
      if (userId !== this.userId) return false;
      return true;
    },

  },

  methods: {

    blockUser() {
      Vue.$loading.on();
      axios.put(`users/${this.userId}/block`).then(() => {
        Vue.$loading.off();
        this.fetchProfileData();
        this.$message.success('Пользователь заблокирован.');
      }).catch(() => {
        Vue.$loading.off();
        this.$notify.error('Ошибка при блокировке пользователя.');
      });
    },

    unblockUser() {
      Vue.$loading.on();
      axios.put(`users/${this.userId}/unblock`).then(() => {
        Vue.$loading.off();
        this.fetchProfileData();
        this.$message.success('Пользователь разблокирован.');
      }).catch(() => {
        Vue.$loading.off();
        this.$notify.error('Ошибка при разблокировке пользователя.');
      });
    },

    bookmarkedClicked() {
      const curUserId = this.$store.getters['user/getUserId'];
      if (!this.isBookmarked) {
        axios.put(`bookmarks/${curUserId}/${this.userId}?entityType=User`).then(() => {
          this.isBookmarked = true;
          this.$message.success(
            'Пользователь добавлен в раздел «Мои контакты» вашего личного кабинета.');
        });
      } else {
        axios.delete(`bookmarks/${curUserId}/${this.userId}?entityType=User`).then(() => {
          this.isBookmarked = false;
          this.$message.success(
            'Пользователь удален из раздела «Мои контакты» вашего личного кабинета.');
        });
      }
    },

    fetchUserData(userId) {
      this.fetchProfileData();

      axios.get(`users/avatar/${userId}`).then((r) => {
        this.avatar = r.data;
      }).catch(() => {
        this.$notify.error('Ошибка при загрузке изображения пользователя.');
      });

      axios.get(`/users/${userId}/gamestatus`).then((r) => {
        this.gameData = r.data;
        const mainRole = {};
        mainRole.Rank = this.gameData.Rank;
        mainRole.Role = 'USERSTATUS';
        mainRole.RoleTitle = 'Личный рейтинг';
        mainRole.Reputation = this.gameData.Reputation;
        this.userRanks.push(mainRole);
        Object.keys(r.data.Roles).forEach((role) => {
          this.userRanks.push(r.data.Roles[role]);
        });
      }).catch(() => {
        this.$notify.error('Ошибка при получении репутации пользователя.');
      });

      axios.get(`/users/${userId}/roles`).then((r) => {
        Object.keys(r.data).forEach((right) => {
          if (r.data[right].Role === 'IP_USER') {
            this.isIPUser = true;
            this.userRights.push(r.data[right]);
          } else if (r.data[right].Role === 'MODERATOR'
            || r.data[right].Role === 'ORG_ADMIN'
            || r.data[right].Role === 'SYS_ADMIN') {
            this.userRights.push(r.data[right]);
          }
        });
      }).catch(() => {
        this.$notify.error('Ошибка при получении ролей пользователя.');
      });

      if (this.$store.getters['user/isAuthenticated']) {
        const curUserId = this.$store.getters['user/getUserId'];
        axios.get(`/bookmarks/${curUserId}?entityType=User`).then((r) => {
          this.isBookmarked = r.data.findIndex(
            user => user.UserId === this.userId) > -1;
        }).catch(() => {});
      }
    },

    fetchProfileData() {
      axios.get(`users/${this.userId}/profile`).then((r) => {
        this.userData = r.data;
      }).catch(() => {
        this.$notify.error('Ошибка при загрузке данных пользователя. Повторите запрос позже.');
      });
    },

    getRoleRank(rankName) {
      const ranks = {
        NOVICE: 1,
        ADVANCED: 2,
        EXPERT: 3,
        MENTOR: 4,
      };
      if (ranks[rankName]) return ranks[rankName];
      return 0;
    },

    convertScoreToSting(score) {
      const lastDigit = parseInt(Math.abs(score).toString().split('').pop(), 10);
      let scoreString = `${score} Балл`;
      if (lastDigit === 0 || lastDigit > 4) scoreString = `${scoreString}ов`;
      else if (lastDigit > 1 && lastDigit <= 4) scoreString = `${scoreString}а`;
      return scoreString;
    },

    getGameElementScore(action) {
      let resultString = '';
      if (action.Score === 0) return resultString;
      resultString = this.convertScoreToSting(action.Score);
      if (action.Action === 'PROFILE_FILLED' || action.Action === 'WITHDRAW_SCORE') return resultString;
      if (action.Number && action.NumberTitle) {
        resultString = `${resultString} / ${action.Number} ${action.NumberTitle}`;
      }
      return resultString;
    },

    getGameElementReputation(action) {
      let resultString = '';
      resultString = this.convertScoreToSting(action.Reputation);
      if (action.Action === 'PROFILE_FILLED') return resultString;
      if (action.Number && action.NumberTitle) {
        resultString = `${resultString} / ${action.Number} ${action.NumberTitle}`;
      }
      return resultString;
    },

    deleteUser() {
      this.$confirm('Удалить пользователя? Это действие нельзя отменить!', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Нет',
      }).then(() => {
        axios.delete(`users/${this.userId}`).then(() => {
          this.$message.success('Пользователь удален.');
          if (this.isMyProfile) {
            this.$store.dispatch('user/logout');
          } else {
            this.$router.push({ path: '/' });
          }
        }).catch(() => {
          this.$message.success('Ошибка при удалении пользователя.');
        });
      }).catch(() => {
        this.$message.success('Удаление отменено.');
      });
    },
  },

};
</script>

<style lang="scss">
@import '../styles/common/main';

.user-profile-display_upd {
  @include clearfix;
  .upd_controls {
    @include clearfix;
  }
  .upd_control-btn {
    float: left;
    margin: 0 15px 11px 0;
    width: 110px;
  }
  .upd_icon-btns-wrap {
    float: right;
    .upd_icon-btn {
      float: left;
    }
    .upd_claim-add {
      margin: 3px 10px 0 0;
    }
    .upd_bookmarks {
      margin: 2px 10px 0 0;
    }
    @media (max-width: 900px) {
      float: left;
    }
  }
  &.upd--grad-bg {
    color: #fff !important;
    .block-wrap {
      padding: 50px;
      background: rgba(0, 0, 0, 0.2) !important;
      @media (max-width: 800px) {
        padding: 30px;
      }
    }
  }
  .upd_avatar {
    -webkit-mask-image: url(../../static/grx/hexagon-white.svg);
    mask-image: url(../../static/grx/hexagon-white.svg);
    max-width: 100%;
    height: auto;
  }
  .upd_img-block {
    @include clearfix;
    .upd_img-info-wrap {
      margin-top: 20px;
      overflow: hidden;
    }
  }
  .upd_job-block {
    @include clearfix;
    padding-top: 20px;
    .upd_job_title {
      font-size: 22px;
      line-height: 25px;
    }
    .upd_job_org {
      font-size: 18px;
      line-height: 20px;
      margin-top: 15px;
      opacity: .7;
      font-weight: 300;
    }
    .upd_job_dep {
      font-size: 18px;
      line-height: 20px;
      margin-top: 15px;
      opacity: .7;
      font-weight: 300;
    }
    .upd_job_post {
      opacity: .7;
      margin-top: 15px;
      font-weight: 500;
    }
  }
  .user-reputation {
    margin-top: 15px;
    font-size: 22px;
    &:before {
      display: inline-block;
      content: '';
      width: 20px;
      height: 20px;
      background: 0 0 no-repeat url(../../static/grx/icons/game-score.svg);
    }
  }
  .role-statuses {
    padding-top: 20px;
    .role-status-main {
      background-color: rgba(196, 196, 196, 0.3)
    }
    .role-status {
      padding: 10px 10px 10px 25px;
      .role-score {
        float: right;
        opacity: 1;
        min-width: 200px;
        text-align: left;
      }
      .role-secondary {
        font-weight: bold;
      }
      .role-main {
        font-size: 22px;
        font-weight: normal;
      }
      .role-rank {
        .rank-fill-ico,
        .rank-empty-ico {
          width: 22px;
          height: 20px;
          display: inline-block;
        }
        .rank-fill-ico {
          background: 0 0 no-repeat url(../../static/grx/icons/rank-filled.svg);
        }
        .rank-empty-ico {
          background: 0 0 no-repeat url(../../static/grx/icons/rank-empty.svg);
        }
      }
      .role-next-status {
        opacity: 0.7;
      }
    }
  }
  .upd_game-block {
    padding-top: 40px;
    .action_item {
      padding-left: 25px;
      padding-right: 15px;
      margin-top: 5px;
      .game_el_value {
        float: right;
        opacity: 1;
        min-width: 200px;
        text-align: left;
      }
      .game_el_name {
        opacity: 0.7;
      }
    }
    .game-count {
      padding-left: 30px;
    }
    @mixin game-button {
      cursor: pointer;
      margin-left: 5px;
      padding-right: 5px;
      display: inline-block;
      border-bottom: 1px dashed;
      font-size: 22px;
    }
    .game-score-button {
      @include game-button;
    }
    .game-reputation-button {
      @include game-button;
    }
    .upd_game_score {
      padding-bottom: 20px;
      .action_item:nth-of-type(odd) {
        background-color: rgba(196, 196, 196, 0.3);
      }
      &:before {
        display: inline-block;
        content: '';
        width: 20px;
        height: 20px;
        background: 0 0 no-repeat url(../../static/grx/icons/game-score.svg);
      }
    }
    .upd_game_reputation {
      .action_item:nth-of-type(odd) {
        background-color: rgba(196, 196, 196, 0.3);
      }
      &:before {
        display: inline-block;
        content: '';
        width: 20px;
        height: 20px;
        background: 0 0 no-repeat url(../../static/grx/icons/game-reputation.svg);
      }
    }
  }
  .upd_avatar {
    float: left;
    margin-right: 40px;
    @media (max-width: 650px) {
      float: none;
      margin: 0 auto;
      display: block;
    }
  }
  .user-rights {
    font-size: 14px;
    .user-rights-title {
      opacity: 0.7;
    }
  }
  .upd_fio {
    font-size: 25px;
    line-height: 27px;
    padding-top: 20px;
    @media (max-width: 650px) {
      padding-top: 15px;
      clear: both;
    }
    .ip-user {
      display: inline-block;
      width: 20px;
      height: 20px;
      background: 0 0 no-repeat url(../../static/grx/icons/person-ipuser.svg);
    }
  }
  .upd_grade {
    font-size: 17px;
    line-height: 19px;
    margin-top: 15px;
    .upd_grade_title {
      font-weight: 300;
      opacity: .7;
    }
  }
  .upd_icon {
    opacity: .5;
    display: inline-block;
    margin-right: 9px;
  }
  .upd_org {
    font-size: 19px;
    line-height: 21px;
    margin-top: 15px;
  }
  .upd_info {
    margin-top: 15px;
  }
  .upd_user-blocked {
    margin-bottom: 15px;
    .upd_user-blocked-icon {
      color: #d35353;
      margin-right: 4px;
    }
    .upd_block-user-ctr {
      display: inline-block;
      border: 1px solid #d35353;
      padding: 5px 15px 5px 10px;
      font-size: 13px;
      @include border-radius(10px);
    }
  }
  &.theme-w {
    .block-wrap {
      background: none;
    }
  }
  &.theme-b {}
}
</style>



// WEBPACK FOOTER //
// src/components/UserProfileDisplay.vue